import { render, staticRenderFns } from "./SystemUpdates.vue?vue&type=template&id=288cebed&scoped=true&"
import script from "./SystemUpdates.vue?vue&type=script&lang=js&"
export * from "./SystemUpdates.vue?vue&type=script&lang=js&"
import style0 from "./SystemUpdates.vue?vue&type=style&index=0&id=288cebed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288cebed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VChip,VCol,VDivider,VIcon,VRow,VToolbar})
